import { SVG } from 'components/HeadlessCMS/svg';
import React, { useState } from 'react';
import './carousal.scss';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from 'reactstrap';
import { toast } from 'react-toastify';
import Axios from 'functions/Axios';
import { CMS_API_URL } from 'Constant';
import { saveAs } from 'file-saver';

type Props = {
  className?: string;
  children: React.ReactNode;
  items: any;
  isSlider: boolean;
  disabled: boolean;
  click: (e: any) => void;
  item: any;
};

export const CarousalC: React.FC<Props> = ({
  className,
  children,
  items,
  disabled,
  isSlider = true,
  click = () => {},
  item,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [animating, setAnimating] = useState<Boolean>(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(items[activeIndex].filePath);
    toast.success('Link copied to clipboard!');
  };
  const downloadImage = async () => {
    const url = items[activeIndex]; // Assuming items and activeIndex are defined in your component state

    try {
      const response = await Axios.post(
        `${CMS_API_URL}/media/download/${url.id}`,
        {},
        {
          responseType: 'blob', // Ensures the response is returned as a blob
        },
      );

      // Create a filename based on the altText or default to 'image'
      const fileName = url.altText ? `${url.altText}.jpg` : 'image.jpg';

      // Use saveAs from the file-saver library to download the image
      saveAs(response.data, fileName);
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  const Indicators = () => {
    return (
      <div className="Ecollat_indicators" style={{ opacity: disabled ? 0.6 : 1 }}>
        <div className="indicator_buttons">
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) return;
              copyToClipboard();
            }}
          >
            {SVG.copy}
          </div>
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) return;
              downloadImage();
            }}
          >
            {SVG.Download}
          </div>
          <div
            className="indicator_box"
            onClick={() => {
              if (disabled) {
                return;
              }
              click(item);
            }}
          >
            {SVG.edit}
          </div>
        </div>
      </div>
    );
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    if (!isSlider) {
      return (
        <div style={{ height: '11rem', width: '100%', backgroundImage: `url(${item.src})` }}></div>
      );
    }

    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img
          src={item.src}
          style={{
            height: '100px', // Set a fixed height, or use '100%' if you want it to adapt to the container
            width: '100%',
            objectFit: 'cover', // Ensures the image covers the container without distortion
          }}
          alt={item.altText}
        />
        {/* <CarouselCaption captionText={item.caption} captionHeader={item.caption} /> */}
      </CarouselItem>
    );
  });

  return (
    <Carousel className={className} activeIndex={activeIndex} next={next} previous={previous}>
      <Indicators />
      {/* <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} /> */}

      {slides}
      {items.length > 1 && (
        <>
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
        </>
      )}
    </Carousel>
  );
};
